import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import masterService from 'services/MasterService';

export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const departmentListAll = createAsyncThunk('/department/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDepartment(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
});

export const departmentSlice = createSlice({
    name: 'department',
    initialState,
    reducers: {

        departmentList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(departmentListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(departmentListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})

export const {
    departmentList
} = departmentSlice.actions

export default departmentSlice.reducer